import { render, staticRenderFns } from "./Presencial.vue?vue&type=template&id=3fc85f52"
import script from "./Presencial.vue?vue&type=script&lang=js"
export * from "./Presencial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports